import * as Halogen$dVDom$dDOM from "../Halogen.VDom.DOM/index.js";
import * as Halogen$dVDom$dMachine from "../Halogen.VDom.Machine/index.js";
import * as Halogen$dVDom$dUtil from "../Halogen.VDom.Util/index.js";
const $Thunk = (_1, _2, _3, _4) => ({tag: "Thunk", _1, _2, _3, _4});
const Thunk = value0 => value1 => value2 => value3 => $Thunk(value0, value1, value2, value3);
const unsafeEqThunk = (v, $0) => Halogen$dVDom$dUtil.refEq(v._1, $0._1) && Halogen$dVDom$dUtil.refEq(v._2, $0._2) && v._2(v._4, $0._4);
const thunk = (tid, eqFn, f, a) => $Thunk(tid, eqFn, f, a);
const thunk1 = (f, a) => thunk(f, Halogen$dVDom$dUtil.refEq, f, a);
const thunk2 = (f, a, b) => thunk(f, (a$1, b$1) => Halogen$dVDom$dUtil.refEq(a$1._1, b$1._1) && Halogen$dVDom$dUtil.refEq(a$1._2, b$1._2), v => f(v._1)(v._2), {_1: a, _2: b});
const thunk3 = (f, a, b, c) => thunk(
  f,
  (a$1, b$1) => Halogen$dVDom$dUtil.refEq(a$1._1, b$1._1) && Halogen$dVDom$dUtil.refEq(a$1._2, b$1._2) && Halogen$dVDom$dUtil.refEq(a$1._3, b$1._3),
  v => f(v._1)(v._2)(v._3),
  {_1: a, _2: b, _3: c}
);
const thunked = eqFn => f => a => thunk({f}, ($0, $1) => eqFn($0)($1), f, a);
const runThunk = v => v._3(v._4);
const mapThunk = k => v => $Thunk(v._1, v._2, x => k(v._3(x)), v._4);
const hoist = mapThunk;
const functorThunk = dictFunctor => (
  {
    map: f => v => $Thunk(
      v._1,
      v._2,
      (() => {
        const $0 = dictFunctor.map(f);
        return x => $0(v._3(x));
      })(),
      v._4
    )
  }
);
const buildThunk = toVDom => {
  const patchThunk = (state, t2) => {
    if (unsafeEqThunk(state.thunk, t2)) {
      const $0 = Halogen$dVDom$dMachine.$Step$p(
        state.vdom._1,
        state,
        patchThunk,
        state$1 => {
          const $0 = state$1.vdom;
          return Halogen$dVDom$dMachine.halt($0);
        }
      );
      return $0;
    }
    const $0 = toVDom(t2._3(t2._4));
    const vdom = Halogen$dVDom$dMachine.step(state.vdom, $0);
    return Halogen$dVDom$dMachine.$Step$p(
      vdom._1,
      {vdom, thunk: t2},
      patchThunk,
      state$1 => {
        const $1 = state$1.vdom;
        return Halogen$dVDom$dMachine.halt($1);
      }
    );
  };
  return spec => t => {
    const $0 = toVDom(t._3(t._4));
    const vdom = Halogen$dVDom$dDOM.buildVDom(spec)($0);
    return Halogen$dVDom$dMachine.$Step$p(
      vdom._1,
      {thunk: t, vdom},
      patchThunk,
      state => {
        const $1 = state.vdom;
        return Halogen$dVDom$dMachine.halt($1);
      }
    );
  };
};
export {$Thunk, Thunk, buildThunk, functorThunk, hoist, mapThunk, runThunk, thunk, thunk1, thunk2, thunk3, thunked, unsafeEqThunk};
